import { put, call } from 'redux-saga/effects';
import { scheduleTaskCreateAPI, scheduleTaskSearchAPI, scheduleTaskUpdateAPI, scheduleTaskUploadAPI } from 'src/api/ScheduleTaskApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { SCHEDULE_TASK_ACTIONS } from '../actions/ScheduleTaskActions';
import { toast } from 'react-toastify';

function* search({
    where, currentPage = 0, autopopulate = true,
} = {}) {
    try {
        const {
            data,
            hierarchy,
            taskCompletionStatus,
            taskSkipStatus
        } = yield call(scheduleTaskSearchAPI, {
            where,
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_SEARCH_SUCCESS,
            data,
            hierarchy,
            taskCompletionStatus,
            taskSkipStatus
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_SEARCH_ERROR,
        });
        return null;
    }
}


function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(scheduleTaskCreateAPI, payload);
        yield put(headerShowAction({
            data: 'Created',
        }));
        toast("Task Created")

        yield put({
            type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data?._id,
            },
        });
        yield put({
            type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_RESET
        });
        yield put({
            type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_SEARCH
        });
    }
    catch (error) {
        // toast.error(error?.message);
        toast.error(error?.response?.data?.message);
        yield put({
            type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_UPSERT_ERROR,
        });
    }
}
function* update(scheduleTaskId, payload) {
    try {
        yield call(scheduleTaskUpdateAPI, {
            scheduleTaskId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if (payload.deleted === true) {
            toast("Task deleted")
        }
        else {
            toast("Project Task updated")
        }

        yield put({
            type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        toast.error(error?.response?.data?.message);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    console.log('LOG: upsert', _id, payload);
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_SEARCH, search),
    takeFirstSagaUtil(SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_UPSERT, upsert),
    // takeFirstSagaUtil(SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_EDIT, edit),
];
